export type StepOperator =
    'INPUT' | 'PROMPT' | 'PRINT' | 'DATA' |
    'NOTIFY' | 'SCRIPT' | 'SELECT' | 'PICTURE' | 'VIDEO' | 'GOTO_STEP' | 'CODE' | `PROMPT_${number}` | 'SPEECH' | 'TRANSCRIBE' | 'LOG' | 'REQUEST' | 'TIMER';

  export const StepOperators = [
    'PRINT', 'PROMPT', 'INPUT', 'DATA', 'NOTIFY', 'SCRIPT', 'SELECT', 'PICTURE', 'VIDEO', 'GOTO_STEP', 'CODE', 'SPEECH', 'TRANSCRIBE', 'LOG', 'REQUEST', 'TIMER'
  ]

  export interface Scenario {
    ID: number;
    Name: string;
    Description: string;
    ScriptID: string;
    CreatedAt: string;
    AssistantID: number;
    IsDefault: boolean;
}

export interface Step {
    ID: number;
    Step: number;
    Operator: StepOperator;
    Content: string;
    Name: string;
    AssistantID: number;
    ScenarioID: number;
    Context: number;
    Params: {
        role: string,
        lang: string,
        voice: string;
        method: string;
        json: string;
        headers: string;
        form: string;
        step: string;
    }
}

export interface CreateStepData {
    name: string;
    assistant_id: number;
    scenario_id: number;
    content: string;
    operator: StepOperator;
    step: number;
    context?: number;
}

export interface UpdateStepData {
    id: number;
    name: string;
    assistant_id: number;
    scenario_id: number;
    step_number?: number;
    content: string;
    operator: StepOperator;
    step: number;
    context: number;
    params?: Record<string, any>
}


export interface CreateAssistantData {
    name: string;
    description: string;
    tg_token: string;
    model: string;
    scenario_id: number;
    image?: File;
}

export interface UpdateAssistantData {
    id: number;
    name?: string;
    description?: string;
    tg_token?: string;
    model?: string;
    scenario_id?: number;
    image?: File;
}

export interface CreateScenarioData {
    name: string;
    description: string;
    assistant_id: number;
    is_default: boolean;
}

export interface UpdateScenarioData {
    id: number;
    name?: string;
    description?: string;
    is_default?: boolean;
}

export interface IAssistant {
    ID: number;
    UserID: number;
    User: null;
    Name: string;
    Description: string;
    Model: string;
    CreatedAt: string; // или используйте тип Date, если вы преобразуете строку в дату
    LastUpdate: string; // или Date
    LastUsage: string; // или Date
    TgToken: string;
    PictureURL: string;
    IsDeleted: boolean;
    step_count: number;
    new_session_count: number;
    new_session_contact_count: number;
    Integrations: string;
    U: any | null; // Замените `any` на конкретный тип, если он известен
}

export interface RunScenarioRequest {
    metadata: {
        tg_username: string;
        channel: string;
        chat_id: string;
    };
    start_step_number: number;
    scenario_id: number;
    input_string: string;
    only_new: boolean;
    restart: boolean;
}

export interface RunScenarioResponse {
    status: string;
    message: string;
    data?: any;
}
